
import React, { useEffect, useRef, useState } from 'react'
import { saveSectionBulk } from '../../../api/testSeries/section';
import { Link, useHistory, useParams } from "react-router-dom"
var mammoth = require("mammoth/mammoth.browser");

const DocxParser = ({ sectionComRef,fileFromParent,setLoading }) => {
    const [html, setHtml] = useState()
    const [file, setFile] = useState()
    const fileRef = useRef(null);
    const [language, setLanguage] = useState("English");
    const [questionType, setQuestionType] = useState("MCQ");
    const $ = window.$
    const sectionQuestionsRef = useRef({});
    const sectionRef = useRef({});
    const { testSeriesId } = useParams()
   const [hideDiv,setHideDiv] = useState(true)

    useEffect(() => {
        if (fileFromParent) {
            fileRef.current = fileFromParent
            initiateParsing()
        }
    },[fileFromParent])
    const initiateParsing = async () => {
        setHideDiv(false)
        setLoading(true)
        mammoth.convertToHtml({ arrayBuffer: fileRef.current })
            .then(function (result) {
                var html = result.value;
                var messages = result.messages;
                // console.log(html)
                console.log(messages)
                setHtml(html)
            })
            .catch(function (error) {
                console.error(error);
                setLoading(false)
            });
    }



    useEffect(() => {
        if (html) {

            parseHtml()
        }
    }, [html])
    const parseHtml = () => {
        sectionQuestionsRef.current = {}
        sectionRef.current = {}
        // Select all tables in div with id "docData"
        $('#docData table').each(function () {
            // Initialize variables for question, options, marks, and explanation
            let question = '';
            let options = [];
            let posMarks = '';
            let negMarks = '';
            let explanation = '';
            let section = '';
            let correctPrompt = '';

            // Loop through each row in the table
            $(this).find('tr').each(function () {
                // Get the text content of the first and second cells in the row
                const key = $(this).find('th:eq(0)').text().trim();
                const value = $(this).find('th:eq(1)')
                const value2 = $(this).find('th:eq(2)').text().trim();
                // Check if the key matches one of the expected values
                if (key === 'Question') {
                    question = value.html();
                } else if (key === 'Option') {
                    const isCorrect = value2 === 'Correct'
                    const optionObj = {}
                    optionObj.value = value.html()
                    optionObj.prompt = (options.length + 1)
                    optionObj.isCorrect = isCorrect
                    options.push(optionObj)
                    if (isCorrect) {
                        correctPrompt = options.length + 1;
                    }

                } else if (key === 'Marks') {
                    posMarks = value.text().trim();
                    negMarks = value2;
                } else if (key === 'Solution') {
                    explanation = value.html();
                } else if (key === 'Type') {
                    section = value.text().trim();
                }
            });

            const questionObj = { type: questionType, questionLanguageVarients: [{ options: [], language }] }
            questionObj.questionLanguageVarients[0].value = question
            questionObj.questionLanguageVarients[0].options = options
            questionObj.questionLanguageVarients[0].correctPrompt = correctPrompt
            questionObj.questionLanguageVarients[0].solution = explanation
            questionObj.posMarks = parseFloat(posMarks) || 0
            questionObj.negMarks = parseFloat(negMarks) || 0
            questionObj.section = section
            sectionRef.current[section] = section
            if (sectionQuestionsRef.current[questionObj.section]) {
                sectionQuestionsRef.current[questionObj.section].push(questionObj)
            } else {
                sectionQuestionsRef.current[questionObj.section] = [questionObj]
            }
        });


        makesSections()

    }

    const makesSections = () => {
        const sections = []
        Object.keys(sectionRef.current).forEach((section, index) => {
            const sectionObj = {}
            const sectionQuestions = sectionQuestionsRef.current[section]
            const qcount = sectionQuestions.length
            sectionObj.title = section
            sectionObj.qcount = qcount
            sectionObj.questions = sectionQuestions
            sectionObj.testSeries = {
                id: testSeriesId
            }
            sections.push(sectionObj)

        })
        sectionRef.current = sections
        saveTest()
 
 
    }
 
    const saveTest = async () => {
        console.log("sectionRef.current newdata", sectionRef.current)
        const response = await saveSectionBulk(sectionRef.current)
        if (response.status) {
            sectionComRef.current.fetchSections()
        }
        setHideDiv(true)
        setLoading(false)
    }
    return (
        <div>
            {/* <input type="file" onChange={onFileChange} /> */}
            {!hideDiv ? (
                <div id="docData" style={{ visibility: "hidden" }} dangerouslySetInnerHTML={{ __html: html }}></div>
            ) : null}
        </div>
    )
}

export default DocxParser